// 地址相关 getters/actions
import { canUse as canUseAddr } from '@g/utils/addrUtils'

export const getters = {
  isCompanyAddr (state) {
    const currTradevanAddr = state.currTradevanAddr
    return currTradevanAddr?.isCompany === 1
  },
  // 申报人是否可使用
  tradevansUnshipped (state, getters, rootState) {
    const prepareModel = state.createPrepare
    const shippingRatesInfo = getters.shippingRatesInfo
    const form = state.createForm
    const map = {}
    if (
      prepareModel &&
      prepareModel.parcelsInfo &&
      prepareModel.parcelsInfo.tradevansTptt &&
      shippingRatesInfo.transport
    ) {
      Object.keys(prepareModel.parcelsInfo.tradevansTptt).forEach((key) => {
        if (key.split('-')[0] === shippingRatesInfo.transport) {
          const tItem = prepareModel.parcelsInfo.tradevansTptt[key]
          const jyorder = tItem.jyorders.find(
            (o) => o.jyoSrTransport === shippingRatesInfo.transport
          )
          if (jyorder) {
            if (form.jyoShpMethod === '91') {
              return
            }
            if (
              String(tItem.isCompany) === '1' &&
              (jyorder.jyoStatus !== '5' || jyorder.jyoShpMethod === '91')
            ) {
              return
            }
            map[key.split('-')[1]] = {
              ...tItem,
              jyorder,
            }
          }
        }
      })
    }
    return map
  },
}

export const actions = {
  applyTradevanAddr ({ commit }, tradevanAddr) {
    commit('setTradevanAddrid', tradevanAddr?.addrid || '')
    commit('setCurrTradevanAddr', tradevanAddr)
  },
  async checkCanUseAddr ({ state, commit, rootState, getters, dispatch }, addr) {
    // 检查地址是否可用
    const transport = getters.shippingRatesInfo.transport
    const prepareModel = state.createPrepare
    const form = state.createForm

    const isCompany = String(addr.tradevanAddr.isCompany) === '1'
    if (transport === 'sea') {
      return true
    }
    if (isCompany && !addr.extraInfo.tradevanAddr.label) {
      return false
    }
    if (
      getters.tradevansUnshipped &&
      (getters.tradevansUnshipped[addr.tradevanAddr?.idNum] ||
        getters.tradevansUnshipped[addr.cneeHash])
    ) {
      return false
    }
    if (prepareModel.parcelsInfo.hasPclItemMold2 && isCompany) {
      return false
    }
    if (rootState.edition === 's' && !isCompany) {
      return false
    }
    if (form.useFeeType === 'tax' && addr.tradevanAddr?.ccTypeC3Tot >= 2) {
      return false
    }
    if (!canUseAddr(addr)) {
      return false
    }

    const checkLockRes = await dispatch(
      'address/checkLock',
      {
        addrid: addr.addrid,
      },
      {
        root: true,
      }
    )
    if (checkLockRes.data.error) {
      return false
    }

    const checkAddressRes = await dispatch('checkAddress', {
      addrid: addr.addrid,
      jyAddrid: getters.jyAddrid,
      transport,
      isPtytKits: '0',
      checkTvsTptt: 'Y',
    })
    if (checkAddressRes.data.error) {
      return false
    } else {
      if (checkAddressRes.data.model.tradevansTptt) {
        const map = {}
        Object.values(checkAddressRes.data.model.tradevansTptt).forEach(
          (tItem) => {
            const jyorder = tItem.jyorders.find(
              (o) =>
                o.jyoSrTransport === transport &&
                o.jyoWhsAddrid === getters.jyAddrid
            )
            if (jyorder) {
              map[
                tItem.idNum === addr.tradevanAddr.idNum
                  ? addr.tradevanAddr.idNum
                  : addr.cneeHash
              ] = {
                ...tItem,
                jyorder,
              }
            }
          }
        )
        if (map[addr.tradevanAddr.idNum]) {
          return false
        } else if (map[addr.cneeHash]) {
          return false
        }
      }
    }

    return true
  },
}
